angular.module('angus.controllers').controller('marginAnalysisSubRegSettingsCtrl', [
    '$scope', 'productsService',  'tradeClassService', 'constantsService', 'promiseMonitor', '$q', 'priceCodeService',
    function($scope, productsService, tradeClassService, constantsService, promiseMonitor, $q, priceCodeService) {

        $scope.promiseMonitor = new promiseMonitor();

        $scope.periodIndicators = constantsService.invoicePeriodIndicators.enums;
        $scope.zeroPriceSalesOptions = constantsService.includeExcludeOnly.enums;
        $scope.subscriberAbosKey = $scope.subscriberKey;

        var promise = $q.all([productsService.getProducts($scope.subscriberId)
            .then(function(products) {
                $scope.products = products;
            }),
            tradeClassService.getTradeClasses($scope.subscriberId)
                .then(function(classes) {
                $scope.tradeClasses = classes;
            }),
            priceCodeService.getBasePriceCodes($scope.subscriberAbosKey)
                .then(function(priceCodes)  {
                    $scope.priceCodes = priceCodes;
                })
        ]);

        $scope.promiseMonitor.monitor(promise);
    }
]);